import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { RegexHelper } from 'src/shared/helpers/regexHelper';

export const useSchemaCreateGroupMessageEmail = () => {
  const { t } = useTranslation();
  const requiredMessage = t('common:validationMessages.required');
  const groupMessageRequestPostSchema = yup.object().shape({
    // copyToEmails: yup.string().email().optional(),
    product_id: yup.number().optional(),
    selection_id: yup.number().required(requiredMessage),
    circularName: yup.string().optional().nullable(),
    selectionName: yup.string().optional(),
    recipients: yup
      .string()
      .trim()
      .matches(RegexHelper.emailAddresses, {
        message: t('common:validationMessages.multipleEmail'),
        excludeEmptyString: true,
      }),
    subject: yup
      .string()
      .required(requiredMessage)
      .max(50, t('common:validationMessages.maxLength', { count: 50 })),
    body: yup.string().required(requiredMessage),
    plainText: yup.string().optional(),
    isHTML: yup.boolean().required(),
    useLinkCounter: yup.boolean().optional(),
    sendDate: yup.string().optional(),
    sender: yup.string().email().required(requiredMessage),
    documentIds: yup.string().optional(),
    localAss_id: yup.number().optional(),
    countyAss_id: yup.number().optional(),
    senderTitle: yup.string().required(),
    selectionType: yup.number().optional(),
    speedFormValues: yup.string().optional(),
    speedFormText: yup.string().optional(),
    files: yup.mixed<File[]>().optional().nullable().notRequired(),
    send: yup.boolean().required(),
    includeRecipientsThatHasUnsubscribedFromEmail: yup.boolean().optional(),
    excludedMemberFromSelection: yup.array().of(
      yup.object().shape({
        member_id: yup.number(),
        firstName: yup.string(),
        lastName: yup.string(),
        email: yup.string(),
      }),
    ),
  });

  return groupMessageRequestPostSchema;
};
